import { useEffect, useState } from "react";

import { getStatsTopItems, StatsPeriodFilter } from "services/stats/rest";
import { StatsItemRevenueDto } from "services/stats/restModels";

export interface UseStatsTopItemsResult {
    items: StatsItemRevenueDto[];
    loading: boolean;
    error: boolean;
}

// Топ позиций по выручке за период.
export const useStatsTopItems = (
    filter: StatsPeriodFilter | null,
    limit: number
): UseStatsTopItemsResult => {
    const [items, setItems] = useState<StatsItemRevenueDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const menuId = filter === null ? null : filter.menuId;
    const from = filter === null ? null : filter.from;
    const to = filter === null ? null : filter.to;

    useEffect(() => {
        if (menuId === null || from === null || to === null) {
            setItems([]);
            setLoading(false);
            return undefined;
        }

        let ignore = false;

        setLoading(true);
        setError(false);

        getStatsTopItems({ menuId, from, to }, limit)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setItems(result);
                } else {
                    setError(true);
                    setItems([]);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setItems([]);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, from, to, limit]);

    return { items, loading, error };
};
